import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { FooterInfoService } from 'src/app/services/footer-info.service';
import { GetInfoAndPassService } from 'src/app/services/get-info-and-pass.service';
import { ThemeService } from 'src/app/theme/theme-service.service';


@Component({
  selector: 'app-sign-up-referral-code',
  templateUrl: './sign-up-referral-code.component.html',
  styleUrls: ['./sign-up-referral-code.component.scss']
})
export class SignUpReferralCodeComponent implements OnInit {
  public signUpRefCodeForm: FormGroup;
  public loading = false;
  public submitted = false;
  public refCodeFail: boolean = false;
  public returnUrl: string;
  public error = '';
  public id;
  public refCode: string;
  public accessRightSection: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private ZpDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private footerInfo: FooterInfoService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService
  ) { }

  async ngOnInit() {
    if (this.ZpDataService.loggedIn()) {
      this.ZpDataService.logout(true);
    }
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.signUpRefCodeForm = this.formBuilder.group({
      refCode: ['', Validators.required]
    });
    let refCode = this.route.snapshot.paramMap.get("refCode");
    if (refCode) {
      this.footerInfo.isProfressional = true;
      await this.ZpDataService.setRefCode(refCode);
      this.goto('/sign-up-password');
    } else {
      this.footerInfo.isProfressional = false;
      // if(this.ZpDataService.loggedIn()){
      //   this.ZpDataService.attemptSessionRestore();
      // }
    }
  }

  get f() {
    return this.signUpRefCodeForm.controls;
  }

  goto(url) {
    this.router.navigate([url]);
  }

  async onSubmit() {
    if (this.signUpRefCodeForm.get('refCode').value) {
      // console.log("refcode set: " + this.signUpRefCodeForm.get('refCode').value);
      let refCodeValue = this.signUpRefCodeForm.get('refCode').value;
      this.getInfoAndPassService.getInfoAndPass(refCodeValue)
      await this.ZpDataService.setRefCode(this.signUpRefCodeForm.get('refCode').value);
    }
    this.router.navigate(['/sign-up-password']);
    return;
  }
}
